export const flowSteps = [
  {
    icon: "ri-chat-smile-3-line",
    title: "お問い合わせ",
    text: "お電話・公式LINE・フォームからお気軽にご連絡ください。LINEなら写真を送るだけでもご相談いただけます。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "現地確認・無料お見積もり",
    text: "ご都合の良い日時に伺い、無料でお見積もりします。物量が少なければお値下げできる場合もあります。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "作業内容のご確認",
    text: "お見積もり内容にご納得いただいてから作業開始。追加の作業が必要な場合は、事前に金額をご説明します。",
  },
  {
    icon: "ri-box-3-line",
    title: "片付け・搬出作業",
    text: "仕分け・搬出・片付けまでまとめて対応。重たい家具もそのままの状態でご相談いただけます。",
  },
  {
    icon: "ri-hand-coin-line",
    title: "お支払い・リフォームのご相談",
    text: "作業後にご精算ください。片付け後に修繕やリフォームが必要な場合も、そのままご相談いただけます。",
  },
];